export default __webpack_public_path__ + "static/media/10.3caf3ccc.jpg";